import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const getDefaultPersonContact = (CustomerPositionId ) => http({

    url:ENDPOINTS.BaseInformation.CustomerPosition.default,
    method: 'get',
    params:{
        CustomerPositionId
    }

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const sendBasketAsync = (data , method ) => http({

    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomerSalesOrderApis.CustomerSalesOrder.browse,
    method: method,
    data
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});


export const getSalesOrderById = (Id ) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomerSalesOrderApis.CustomerSalesOrder.load,
    headers: { "Accept-Language": "en" },
    method: 'get',
    params: {
       Id
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});


export const getOrderConstraint = ( ) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomerSalesOrderApis.CustomerSalesOrder.constraint,
    headers: { "Accept-Language": "en" },
    method: 'get',
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});


export const getCustomerPriceListDetail = (Id,priceListId ,code , warehouseId=null ,WarehouseDetailId=null ) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomersStoreApi.CustomersStore.ItemPrice,
    method: 'get',
    params: {
        ItemId:Id,
        ItemCode:code , 
        PriceListId:priceListId,
        WarehouseId:warehouseId,
       WarehouseDetailId
        
   

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});